import DataTable from "react-data-table-component";
import { SyncLoader } from "react-spinners";
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt";
import "./Table.css";



export default function Table({
    tableHeaders,
    headerSelector,
    tableData,
    ActionBtn,
    ViewBtn,
    showLoader,
    withActionData,
    DoneBtn,
    totalItems,
    currentPage,
    itemsPerPage,
    handlePageChange
}) {
    const columns = tableHeaders.map((header, index) => {
        if (header === "-") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: ViewBtn,
                width: "8rem",
                reorder: false,
                wordWrap: "break-word",
            };
        } if (header === "/") {
            return {
                name: "",
                selector: (row) => row[headerSelector[index]],
                button: true,
                cell: DoneBtn,
                width: "8rem",
                reorder: false,
                wordWrap: "break-word",
            };
        }
        /*Banks*/
        else if (header === "BANK NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "25rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        else if (header === "ACCOUNT NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "20rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        else if (header === "ACCOUNT NO.") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "12rem",
                reorder: true,
            };
        }
        else if (header === "ACTIONS" && !withActionData) {
            return {
                name: header,
                button: true,
                cell: ActionBtn,
                width: "8rem",
                reorder: false,
                center: true,
            };
        }
        /*Branches*/
        else if (header === "BRANCH NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "20rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        } 
        else if (header === "TYPE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "11rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        else if (header === "ADDRESS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "20rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        else if ((header === "PHONE NUMBER") || (header === "CONTACT NO.") || (header === "CONTACT PERSON")){
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "11rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word",
            };
        }
        else if (header === "INITIAL CASH IN DRAWER") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                width: "12rem",
                reorder: true,
            };
        }
        else if (header === "STATUS") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                center: true,
                width: "6rem",
                reorder: true,
            };
        }
        /*Forwarders*/
        else if (header === "NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "15rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        /*Terminals*/
        else if (header === "BRANCH") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "13rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        } 
        /*Users*/
        else if (header === "FULL NAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "15rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }  
        else if (header === "USERNAME") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "10rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        else if (header === "ROLE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "11rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        /*Price Level*/
        else if (header === "ITEM DESCRIPTION") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "20rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        else if (header === "PRICE LEVEL") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "12rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        else if ((header === "SELLING") || (header === "WHOLESALE") || (header === "RETAIL")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        /*Employees*/
        else if (header === "DEPARTMENT/BRANCH") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "15rem",
                reorder: true,
                wrap: true,
                sortable: true,
                wordWrap: "break-word",
            };
        }
        else if ( (header === "POSITION") || (header === "EMAIL")) {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "10rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
        else if (header === "DESCRIPTION") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                left: true,
                width: "19rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word",
            };
        }
        else if (header === "ADDON RATE") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                right: true,
                width: "8rem",
                reorder: true,
            };
        }      
        else {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                reorder: true,
                wrap: true,
                wordWrap: "break-word", 
            };
        }
    });

    const paginationComponentOptions = {
        rowsPerPageText: "",
        noRowsPerPage: true,
    };

    const customStyles = {
        rows: {
            style: {
                minHeight: "5.2vh",
            },
        },
    };

    return showLoader ? (
        <div className="d-flex justify-content-center my-5">
            <SyncLoader color="var(--primary-color)" size={15} />
        </div>
    ) : (
        <DataTable
            pagination
            striped
            fixedHeader
            fixedHeaderScrollHeight="50vh"
            columns={columns}
            data={tableData}
            customStyles={customStyles}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={<NoDataPrompt />}
            
            paginationTotalRows={totalItems} // Total number of items for pagination
            paginationPerPage={itemsPerPage} // Items per page
            paginationServer={true} // Enable server-side pagination
            onChangePage={handlePageChange} // Function to handle page change
            currentPage={currentPage}
            paginationDefaultPage={currentPage} 
            // defaultSortFieldId={tableType === 'itemList' && 2}
        />
       
    );
}